import type { ReceiptTemplate } from '../schema';

export const marshallsTemplate: ReceiptTemplate = {
  id: 'marshalls',
  name: 'Marshalls Receipt',
  brand: 'MARSHALLS',
  description: 'Marshalls discount store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'marshalls-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/marshalls.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          'STORE #4892',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'marshalls-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'trans', label: 'Trans:', value: '847291' },
        ],
        column2: [
          { id: 'date', label: '', value: '01/04/2026 2:45PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'marshalls-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'DESIGNER HANDBAG', quantity: '1', price: '49.99', sku: '847291034' },
          { id: '2', name: 'WOMENS BLOUSE', quantity: '1', price: '19.99', sku: '847291035' },
          { id: '3', name: 'MENS BELT', quantity: '1', price: '14.99', sku: '847291036' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'marshalls-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '84.97', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '7.01', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '91.98', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'marshalls-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'marshalls-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'YOUR ICONS. YOUR ICONS.\n\nReturns within 30 days\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

